import { Directive, ElementRef, Input, Renderer2, OnInit } from '@angular/core';
@Directive({
  selector: '[fgbAnimateSvg]',
})
export class AnimateSvgDirective implements OnInit {
  @Input('animation') animationType: string = 'float pulse'; // default both animations
  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}
  ngOnInit(): void {
    const element = this.el.nativeElement;
    // Wrap SVG in animation layers dynamically
    const wrapper = this.renderer.createElement('div');
    const innerWrapper = this.renderer.createElement('div');
    if (this.animationType.includes('float')) {
      this.renderer.addClass(wrapper, 'floating');
    }
    if (this.animationType.includes('pulse')) {
      this.renderer.addClass(innerWrapper, 'pulsing');
    }
    // Move SVG inside new wrappers
    const parent = element.parentNode;
    this.renderer.insertBefore(parent, wrapper, element);
    this.renderer.appendChild(innerWrapper, element);
    this.renderer.appendChild(wrapper, innerWrapper);
  }
}
